import React from 'react';
import { Input, Form, Button, Popover, Select, AutoComplete, message, Tag, Popconfirm } from 'antd';
import { Container, Row, Col } from 'reactstrap';
import SERVER_URL from '../Global';

const InputGroup = Input.Group;
const { Option } = Select;

class HandleGeo extends React.Component {
    constructor(props) {
        super(props);
        let nationSelected = false
        let regionSelected = false
        let provinceSelected = false
        let citySelected = false
        let zipSelected = false

        if (this.props.isEdit) {
            nationSelected = true
            regionSelected = true
            provinceSelected = true
            citySelected = true
            zipSelected = true
        }

        this.state = {
            user: this.props.token,
            nationSelected: nationSelected,
            nationAlreadySaved: false,
            regionSelected: regionSelected,
            provinceSelected: provinceSelected,
            provinceAlreadySelected: false,
            citySelected: citySelected,
            zipSelected: zipSelected,
            nationCreated: false,
            regionCreated: false,
            provinceCreated: false,
            cityCreated: false,
            zipCreated: false,
            nationName: '',
            nationInitials: '',
            alertNationInitials: false,
            regionName: '',
            provinceName: '',
            provinceInitials: '',
            alertProvinceInitials: false,
            cityName: '',
            zipCode: '',
            nationId: '',
            regionId: '',
            provinceId: '',
            cityId: '',
            zipId: '',
            allSaved: true,
            placeCreated: false,
            placeId: '',
            nations: [],
            regions: [],
            provinces: [],
            cities: [],
            zipCodes: [],
            fetching: false,
            createdNationId: 0,
            createdRegionId: 0,
            createdProvinceId: 0,
            createdCityId: 0,
            zipList: [],
            negVal: -1,
        };

        //handlechange, nomi e iniziali
        this.handleCityName = this.handleCityName.bind(this);
        this.handleZipCode = this.handleZipCode.bind(this);
        this.handleNationName = this.handleNationName.bind(this);
        this.handleNationInitials = this.handleNationInitials.bind(this);
        this.handleRegionName = this.handleRegionName.bind(this);
        this.handleProvinceName = this.handleProvinceName.bind(this);
        this.handleProvinceInitials = this.handleProvinceInitials.bind(this);

        //i save, parte sempre il saveAddress
        this.saveAddress = this.saveAddress.bind(this);

        //le select
        this.handleNationId = this.handleNationId.bind(this);
        this.handleRegionId = this.handleRegionId.bind(this);
        this.handleProvinceId = this.handleProvinceId.bind(this);
        this.handleCityId = this.handleCityId.bind(this);
        this.handleZipId = this.handleZipId.bind(this);

        //rimozione tag zip
        this.removeZip = this.removeZip.bind(this);
    }

    componentDidMount() {
        if (this.props.isEdit) {
            fetch(
                `${SERVER_URL + 'api/city/' + this.props.geoEditId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                    }
            }).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        let city = res.data

                        let zipList = []
                        city.brCityZipCodes.map(br => {
                            br.deleted = false
                            br.created = true
                            zipList.push(br)
                        })

                        this.setState({
                            nationName: city.province.region.nation.name,
                            nationInitials: city.province.region.nation.initials,
                            regionName: city.province.region.name,
                            provinceName: city.province.name,
                            provinceInitials: city.province.initials,
                            cityName: city.name,
                            nationId: city.province.region.nation.nationId,
                            regionId: city.province.region.regionId,
                            provinceId: city.province.provinceId,
                            cityId: city.cityId,
                            zipList: zipList
                        })

                    } else {
                        message.error("There has been an error loading this city, you will be redirected to the city list")

                        setTimeout(function () {
                            window.location = "/places/index";
                        }, 3000);
                    }
                })
        }
    }

    handleNationInitials(event) {
        this.setState({ nationInitials: event.target.value, allSaved: false, alertNationInitials: false });

        if (event.target.value.length == 0) {
            this.setState({ nationInitials: '', alertNationInitials: true })
        }
    }

    //nation
    handleNationId(value) {
        var value = parseInt(value)
        if (value != 0) {
            const index = this.state.nations.findIndex(nation => nation.nationId == value);

            this.setState({ nationId: value, allSaved: false, nationSelected: true, nationInitials: this.state.nations[index].initials, nationName: this.state.nations[index].name, nationAlreadySaved: true, alertNationInitials: false });
        } else {            
            this.setState({ nationCreated: true, allSaved: false, nationId: -1, nationSelected: true });
            if (this.state.nationInitials.length == 0) {
                this.setState({ alertNationInitials: true })
            }
        }
    }

    handleNationName(value) {
        if (value != undefined) {
            this.setState({ nationName: value, allSaved: false, nationSelected: false, nationId: this.state.createdNationId, nationAlreadySaved: false });

            if (value.length === 0) {
                this.setState({ nationName: '' })
            }

            fetch(
                `${SERVER_URL + 'api/nation/list'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                    body: JSON.stringify({
                    "name": value,
                    "page": 1,
                    "totalPages": 0,
                    "totalItems": 0,
                    "pageSize": 40,
                    "pageSizeOptions": null,
                    "firstItemNumber": 0,
                    "lastItemNumber": 0,
                    "ordering": {
                        "orderPropertyName": "name",
                        "order": 1
                    },
                    "entityId": 0
                })
            }
            ).then(response => response.json())
                .then(res => {
                    let nations = [{ nationId: 0, name: 'Add New Nation' }]
                    if (res.data != null) {
                        this.setState({ nations: nations.concat(res.data), loading: false, });
                    } else {
                        this.setState({ nations: nations, loading: false });
                    }
                })
        }
    }

    //region
    handleRegionId(value) { 
        var value = parseInt(value)
        if (value != 0 && value != -1) {
            const index = this.state.regions.findIndex(region => region.regionId == value);
            this.setState({ regionId: value, allSaved: false, regionSelected: true, regionName: this.state.regions[index].name });
        } else if (value == 0) {
            this.setState({ regionCreated: true, regionId: -1, regionSelected: true, allSaved: false });
        } else {
            this.setState({ regionCreated: true, regionId: -1, regionSelected: true, allSaved: false, regionName: 'N/A' });
        }
    }

    handleRegionName(value) {
        if (value != undefined) {
            this.setState({ regionName: value, allSaved: false, regionSelected: false, regionId: this.state.createdRegionId });

            if (value.length === 0) {
                this.setState({ regionName: '' })
            }

            fetch(
                `${SERVER_URL + 'api/region/list'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "name": value,
                    "nationId": this.state.nationId,
                    "ExcludeName": '§N.A.§',
                    "page": 1,
                    "totalPages": 0,
                    "totalItems": 0,
                    "pageSize": 40,
                    "pageSizeOptions": null,
                    "firstItemNumber": 0,
                    "lastItemNumber": 0,
                    "ordering": {
                        "orderPropertyName": "name",
                        "order": 1
                    },
                    "entityId": 0
                })
            }
            ).then(response => response.json())
                .then(res => {
                    let regions = [{ regionId: 0, name: 'Add New Region' }, {regionId: -1, name: 'N/A'}]
                    if (res.data != null) {
                        if (res.data.findIndex(reg => reg.name == "N/A") != -1) {
                            regions = [{ regionId: 0, name: 'Add New Region' }]
                        }

                        this.setState({ regions: regions.concat(res.data), loading: false, });
                    } else {
                        this.setState({ regions: regions, loading: false });
                    }
                })
        }
    }

    //province

    handleProvinceInitials(event) {
        this.setState({ provinceInitials: event.target.value, allSaved: false, alertProvinceInitials: false });

        if (event.target.value.length === 0) {
            this.setState({ provinceInitials: '' })
        }
    }


    handleProvinceId(value) {
        var value = parseInt(value)
        if (value != 0 && value != -1) {
            const index = this.state.provinces.findIndex(pro => pro.provinceId == value);

            this.setState({ provinceId: value, allSaved: false, provinceSelected: true, provinceInitials: this.state.provinces[index].initials, provinceName: this.state.provinces[index].name, provinceAlreadySelected: true, alertProvinceInitials: false});
        } else if (value == 0) {
            this.setState({ provinceCreated: true, provinceId: -1, provinceSelected: true, allSaved: false });
            if (this.state.provinceInitials.length == 0) {
                this.setState({ alertProvinceInitials: true });
            }
        } else {
            this.setState({ provinceCreated: true, provinceId: -1, provinceSelected: true, allSaved: false, provinceInitials: 'NA', provinceName: 'N/A', provinceAlreadySelected: true, alertProvinceInitials: false });            

        }
    }

    handleProvinceName(value) {
        this.setState({ provinceName: value, allSaved: false, provinceSelected: false, provinceId: this.state.createdProvinceId, provinceAlreadySelected: false });

        if (value.length === 0) {
            this.setState({ provinceName: '' })
        }

        fetch(
            `${SERVER_URL + 'api/province/list'}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.state.user}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "name": value,
                "regionId": this.state.regionId,
                "ExcludeName": '§N.A.§',
                "page": 1,
                "totalPages": 0,
                "totalItems": 0,
                "pageSize": 40,
                "pageSizeOptions": null,
                "firstItemNumber": 0,
                "lastItemNumber": 0,
                "ordering": {
                    "orderPropertyName": "name",
                    "order": 1
                },
                "entityId": 0
            })
        }
        ).then(response => response.json())
            .then(res => {
                let provinces = [{ provinceId: 0, name: 'Add New Province' }, {provinceId: -1, name: 'N/A'}]
                if (res.data != null) {
                    if (res.data.findIndex(pro => pro.name == "N/A") != -1) {
                        provinces = [{ provinceId: 0, name: 'Add New Region' }]
                    }

                    this.setState({ provinces: provinces.concat(res.data), loading: false });
                } else {
                    this.setState({ provinces: provinces, loading: false });
                }
            })
    }

    //city
    handleCityId(value) {
        var value = parseInt(value)
        if (value != 0) {
            const index = this.state.cities.findIndex(city => city.cityId == value);

            this.setState({ cityId: value, allSaved: false, citySelected: true, cityName: this.state.cities[index].name });
        } else {
            this.setState({ cityCreated: true, cityId: -1, allSaved: false, citySelected: true });
        }
    }

    handleCityName(value) {
        this.setState({ cityName: value, allSaved: false, citySelected: false, cityId: this.state.createdCityId });

        if (value.length === 0) {
            this.setState({ cityName: '' })
        }

        fetch(
            `${SERVER_URL + 'api/city/list'}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.state.user}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "name": value,
                "provinceId": this.state.provinceId,
                "page": 1,
                "totalPages": 0,
                "totalItems": 0,
                "pageSize": 40,
                "pageSizeOptions": null,
                "firstItemNumber": 0,
                "lastItemNumber": 0,
                "ordering": {
                    "orderPropertyName": "name",
                    "order": 1
                },
                "entityId": 0
            })
        }
        ).then(response => response.json())
            .then(res => {
                let cities = [{ cityId: 0, name: 'Add New City' }]
                if (res.data != null) {
                    this.setState({ cities: cities.concat(res.data), loading: false });
                } else {
                    this.setState({ cities: cities, loading: false });
                }
            })
    }

    //zipcode

    removeZip(id) {
        const index = this.state.zipList.findIndex(zip => zip.zipCodeId == id);

        let zipList = this.state.zipList
        zipList[index].deleted = true
        this.setState({ zipList: zipList, allSaved: false })
    }

    handleZipId(value) {
        var value = parseInt(value)
        if (value != 0) {
            const index = this.state.zipCodes.findIndex(zip => zip.zipCodeId == value);
            let zipList = this.state.zipList
            zipList.push({ zipCodeId: value, value: this.state.zipCodes[index].value, deleted: false, created: false, zipCode: { value: this.state.zipCodes[index].value } })

            this.setState({ zipId: value, allSaved: false, zipSelected: true, zipCode: null });
        } else {
            let zipList = this.state.zipList

            let negativeValue = this.state.negVal

            //se esiste già uno zipCodeId -1 allora dai come nuovo ZipCodeId -2 e così via
                
            /*zipList.map(zip => {
                if (zip.zipCodeId == this.state.negVal) {
                    negativeValue = this.state.negVal - 1
                    this.setState({ negVal: negativeValue });
                }
            }) */
            
            zipList.push({ zipCodeId: negativeValue, value: this.state.zipCode, deleted: false, created: false, zipCode: { value: this.state.zipCode } })
            this.setState({ zipSelected: true, allSaved: false, zipList: zipList, zipCode: null });
        }
    }

    handleZipCode(value) {        
        this.setState({ zipCode: value, allSaved: false });        
        if (value.length === 0) {
            this.setState({ zipCode: '', zipCodes: [] })
        } else if (value.length > 2) {
            fetch(
                `${SERVER_URL + 'api/zipcode/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "value": value,
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 40,
                        "pageSizeOptions": null,
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "ordering": {
                            "orderPropertyName": "name",
                            "order": 1
                        },
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    let zipCodes = [{ zipCodeId: 0, value: 'Add New Zip Code' }]

                    if (res.data != null) {
                        this.setState({ zipCodes: zipCodes.concat(res.data), loading: false });
                    } else {
                        this.setState({ zipCodes: zipCodes, loading: false });
                    }
                })
        } else {
            this.setState({ zipCodes: [] })
        }
    }

    saveAddress() {
        var zipCodes = []
        this.state.zipList.map(zip => {
            if (!zip.deleted) {
                zipCodes.push({ value: zip.zipCode.value, zipCodeId: zip.zipCodeId })
            } else {
                fetch(`${SERVER_URL + 'api/BrCityZipCode/hard/' + this.state.cityId + "/" + zip.zipCodeId}`, {
                    method: 'DELETE',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    }
                })
            }
        })

        //salva la natione se è già stata creata
        fetch(`${SERVER_URL + 'api/address/geoaddress'}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.user}`,
            },
            body: JSON.stringify({
                "nation": {
                    'name': this.state.nationName,
                    'initials': this.state.nationInitials,
                    'nationId': this.state.nationId
                },
                "region": {
                    'name': this.state.regionName,
                    'nationId': this.state.nationId,
                    'regionId': this.state.regionId
                },
                "province": {
                    'name': this.state.provinceName,
                    'regionId': this.state.regionId,
                    'initials': this.state.provinceInitials,
                    'provinceId': this.state.provinceId
                },
                "city": {
                    'name': this.state.cityName,
                    "cityId": this.state.cityId,
                    'provinceId': this.state.provinceId
                },
                zipCodes
            })
        }).then(response => response.json())
            .then(res => {
                if (res.ok) {
                    res.data.zipCodes.map(zip => {
                        var index = this.state.zipList.findIndex(zip => zip.zipCode.value == zip.value);

                        if (index != -1) {
                            this.state.zipList[index].zipCodeId = zip.zipCodeId
                        }
                    })

                this.props.parentCallbackGeoSaved(true)
                this.setState({ allSaved: true, nationId: res.data.nation.nationId, regionId: res.data.region.regionId, provinceId: res.data.province.provinceId, cityId: res.data.city.cityId })
                } else {
                message.warning(res.errorMessage)
            }
        })
    }

    render() {

        let city = this.state.cityName !== null ? this.state.cityName : ''

        let zipCode = this.state.zipSelected ? this.state.zipList.map((zip, i) => {
            if (!zip.deleted) {
                return <span key={zip.zipCodeId + i}>{zip.zipCode.value}</span>
            }
        }): ''

        let natInitials = this.state.nationInitials !== null ? this.state.nationInitials : ''

        let initials = this.state.provinceInitials !== null ? this.state.provinceInitials : ''

        let allSavedBlock = <p style={{ marginBottom: 0 }}>Everything is already Saved</p>

        let somethingNotOk = <p style={{ marginBottom: 0 }}>Something has not been entered</p>

        let previewCodes = this.state.cityName != '' ? <div>{this.state.nationName}({this.state.nationInitials}), {this.state.regionName} - {this.state.provinceName}({this.state.provinceInitials}), {city} - <div style={{ display: 'inline' }} className="categoryNameList">{zipCode}</div></div> : ''

        let previewConfirm = `${this.state.nationName}(${this.state.nationInitials}), ${this.state.regionName} - ${this.state.provinceName}(${this.state.provinceInitials}), ${this.state.cityName} ${this.state.zipList.map(zip => { if (!zip.deleted) { return zip.zipCode.value } })}`

        var zipExisting = false

        this.state.zipList.map(zip => {
            if (!zip.deleted) {
                zipExisting = true
            }
        })

        let savePlace = this.state.allSaved ?
            <div className="saveButtonBox">
                <Popover content={allSavedBlock}>
                    <Button disabled className="saveButtonHrWizard" icon="save">Save Place</Button>
                </Popover>
            </div>
            : this.state.regionName == '' || this.state.cityName == '' || this.state.provinceName == '' || this.state.provinceInitials == '' || !zipExisting ?
                <div className="saveButtonBox">
                    <Popover content={somethingNotOk}>
                        <Button disabled className="saveButtonHrWizard" icon="save">Save Place</Button>
                    </Popover>
                </div>
                :
                <div className="saveButtonBox">
                    <Popconfirm title={"Are you sure to save " + previewConfirm + "?"}
                        onConfirm={this.saveAddress}
                        okText="Yes"
                        cancelText="No">
                        <Button className="saveButtonHrWizard" icon="save">Save Place</Button>
                    </Popconfirm>
                </div>

        let listaNations = this.state.nations.map(nat => {
            return (<Option key={nat.nationId}>{nat.name}</Option>)
        })

        let listaRegions = this.state.regions.map(reg => {
            return (<Option key={reg.regionId}>{reg.name}</Option>)
        })

        let listaProvinces = this.state.provinces.map(pro => {
            return (<Option key={pro.provinceId}>{pro.name}</Option>)
        })

        let listaCities = this.state.cities.map(city => {
            return (<Option key={city.cityId}>{city.name}</Option>)
        })

        let listaZip = this.state.zipCodes.map(zip => {
            return (<Option key={zip.zipCodeId}>{zip.value}</Option>)
        })        

        let regionNotEditablePopoverContent = "Nation or Nation Initials not selected"

        let cityNotEditablePopoverContent = "Province or Province Initials not selected"

        let regionEditable = this.state.nationSelected && this.state.nationInitials.length == 2 ?
            <AutoComplete               
                dataSource={listaRegions}
                style={{ width: '100%' }}
                onSelect={this.handleRegionId}
                onSearch={this.handleRegionName}
                placeholder="Region"
                allowClear
                className="handleTyp"
                value={this.state.regionName}
            />
            :            
            <Popover content={regionNotEditablePopoverContent}>
                <AutoComplete
                    disabled
                    dataSource={listaRegions}
                    style={{ width: '100%' }}
                    onSelect={this.handleRegionId}
                    onSearch={this.handleRegionName}
                    placeholder="Region"
                    allowClear
                    className="handleTyp"
                    value={this.state.regionName}
                />
            </Popover>

        let cityEditable = this.state.provinceSelected && this.state.provinceInitials.length == 2 ?
            <AutoComplete              
                dataSource={listaCities}
                style={{ width: '100%' }}
                onSelect={this.handleCityId}
                onSearch={this.handleCityName}
                placeholder="City"
                allowClear
                className="handleTyp"
                value={this.state.cityName}
            />
            :
            <Popover content={cityNotEditablePopoverContent}>
                <AutoComplete
                    disabled
                    dataSource={listaCities}
                    style={{ width: '100%' }}
                    onSelect={this.handleCityId}
                    onSearch={this.handleCityName}
                    placeholder="City"
                    allowClear
                    className="handleTyp"
                    value={this.state.cityName}
                />
            </Popover>

        return (
            <Col sm="12" className="modifyPlaceBox" style={{ width: '25%' }}>
                <div className={"modifyHr" + this.state.allSaved}>
                    <h3 style={{ fontSize: '20px', minHeight: '1.2em' }}>
                        {previewCodes}
                    </h3>
                    <Form>
                        <Row className="formGeoRegion" style={{ width: '100%' }}>
                            <Col>
                                <Form.Item label={`Nation`}>
                                    <InputGroup compact style={{ marginTop: 4 }}>
                                        <AutoComplete
                                            dataSource={listaNations}
                                            style={{ width: '70%' }}
                                            onSelect={this.handleNationId}
                                            onSearch={this.handleNationName}
                                            placeholder="Nation"
                                            allowClear
                                            className="handleTyp  no-board"
                                            value={this.state.nationName}
                                        />
                                        <Input maxLength={2} className={"alertNationInitials" + this.state.alertNationInitials} disabled={this.state.nationAlreadySaved} style={{ width: '30%', height: 40, zIndex: '1' }} autoComplete="new-password" value={natInitials} placeholder="Initials" onChange={this.handleNationInitials} />
                                    </InputGroup>
                                </Form.Item>
                            </Col>

                            <Col>
                                <Form.Item label={`Region`}>
                                    {regionEditable}
                                </Form.Item>
                            </Col>

                            <Col>
                                <Form.Item label={`Province`}>
                                    <InputGroup compact style={{ marginTop: 4 }}>
                                        <AutoComplete
                                            disabled={!this.state.regionSelected}
                                            dataSource={listaProvinces}
                                            style={{ width: '70%', border:'0px solid' }}
                                            onSelect={this.handleProvinceId}
                                            onSearch={this.handleProvinceName}
                                            placeholder="Province"
                                            allowClear
                                            className="handleTyp no-board"
                                            value={this.state.provinceName}
                                        />
                                        <Input maxLength={2} className={"alertProvinceInitials" + this.state.alertProvinceInitials} disabled={!this.state.regionSelected || this.state.provinceAlreadySelected} style={{ width: '30%', height: 40, zIndex: '1' }} autoComplete="new-password" value={initials} placeholder="Initials" onChange={this.handleProvinceInitials} />
                                    </InputGroup>
                                </Form.Item>
                            </Col>

                            <Col>
                                <Form.Item label={`City`}>
                                    {cityEditable}
                                </Form.Item>
                            </Col>

                            <Col>
                                <Form.Item label={`Zip`}>
                                    <AutoComplete
                                        disabled={!this.state.citySelected}
                                        dataSource={listaZip}
                                        style={{ width: '100%' }}
                                        onSelect={this.handleZipId}
                                        onSearch={this.handleZipCode}
                                        placeholder="Zip Code"
                                        allowClear
                                        className="handleTyp"
                                        value={this.state.zipCode}
                                    />
                                </Form.Item>
                                <div className="linkLink categoryTags" style={{ textAlign: 'left' }}>
                                    {this.state.zipList.map((zip, i) => {
                                        if (!zip.deleted) {
                                            return (
                                                <Tag className="cat" closable key={zip.zipCodeId + i} onClick={() => this.removeZip(zip.zipCodeId)}>
                                                    <span>{zip.zipCode.value}</span>
                                                </Tag>
                                            )
                                        }}                                    
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </Form>

                    {savePlace}
                </div>
            </Col>
        );
    }
}

export default HandleGeo;


// WEBPACK FOOTER //
// ./src/GeoRegion/HandleGeo.js